import { gql } from '@apollo/client'
import { scorecardData, commentaryData, oversData, liveInningData } from '@graphql/match'

export const FULL_SCOREBOARD = gql`
  query FetchLiveInningsData($input: liveInningsInput) {
    fetchLiveInningsData(input: $input) {
      ${scorecardData}
    }
  }
`

export const LIVE_INNING_DATA = gql`
  query FetchLiveInningsData($input: liveInningsInput) {
    fetchLiveInningsData(input: $input) {
      ${liveInningData}
    }
  }
`

export const MATCH_DETAIL = gql`
  query GetMatchById($input: oGetMatchByIdInput) {
    getMatchById(input: $input) {
      _id
      dEndDate
      bIsCommentary
      aPoll {
        _id
        dEndDate
        aSlides {
          _id
          sTitle
          nTotalVote
          aField {
            _id
            nVote
            sTitle
            # oMediaUrl {
            #   sUrl
            #   sText
            # }
          }
        }
      }
      oSeo {
        sSlug
        sTitle
        sRobots
        sDescription
        sCUrl
        oTwitter {
          sUrl
          sTitle
          sDescription
        }
        oFB {
          sUrl
          sTitle
          sDescription
        }
        eType
        eStatus
        aKeywords
        _id
        iId
      }
      sResult
      nLatestInningNumber
      sDescription
      sTitle
      sSubtitle
      sStatusStr
      sStatusNote
      sLiveMatchNote
      sLiveGameStatusStr
      sFormatStr
      sEquation
      dStartDate
      oSeries {
        sAbbr
        sSeason
        sTitle
        sStatus
        nTotalTeams
        sSeriesType
        _id
        oSeo {
          sSlug
        }
        oCategory {
          oSeo {
            sSlug
          }
        }
      }
      oWinner {
        _id
      }
      oTeamScoreA {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
          oSeo {
            sSlug
          }
          oTag {
            eStatus
          }
        }
      }
      oVenue {
        sLocation
        sName
      }
      oToss {
        sText
        oWinnerTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
        }
        eDecision
      }
      oTeamScoreB {
        sScoresFull
        sScores
        sOvers
        oTeam {
          _id
          sAbbr
          oImg {
            sUrl
          }
          sTitle
          oSeo {
            sSlug
          }
          oTag {
            eStatus
          }
        }
      }
      oLiveScore {
        nRunrate
        sRequiredRunrate
      }
      aInning {
        sShortName
        nInningNumber
        oBattingTeam {
          sTitle
          oImg {
            sUrl
            sText
          }
        }
        iBattingTeamId
      }
      oMom {
        _id
      }
      oMos {
        _id
      }
      sUmpires
      sReferee
      iEventId
    }
  }
`

export const FANTASY_TIPS_DETAILS = gql`
  query GetOverviewFront($input: oGetOverviewFrontInput) {
    getOverviewFront(input: $input) {
      aCricPrediction {
        _id
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aBenchedPlayers {
          sShortName
          sPlayingRole
          _id
        }
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          _id
        }
        iC
      }
      oTeam2 {
        oTeam {
          sTitle
        }
        aPlayers {
          sShortName
          sPlayingRole
          _id
        }
        iC
        aBenchedPlayers {
          _id
          sPlayingRole
          sShortName
        }
      }
      sMatchPreview
      sNews
      sPitchCondition
      sPitchReport
      sWeatherReport
      sWeatherCondition
      sAvgScore
    }
  }
`

export const GET_FANTASY_PLATFORM = gql`
  query GetFantasyTipsFront($input: oGetFantasyTipsFrontInput) {
    getFantasyTipsFront(input: $input) {
      _id
      oSeo {
        sSlug
      }
      oTeamB {
        sTitle
        _id
      }
      oTeamA {
        sTitle
        _id
      }
      ePlatformType
      dUpdated
      aLeague {
        aTeam {
          aSelectedPlayerFan {
            _id
            oTeam {
              sTitle
              _id
            }
            oPlayer {
              sFullName
              sFirstName
              sPlayingRole
              sShortName
              _id
              oImg {
                sUrl
                sText
              }
            }
            nRating
            eRole
          }
          oTeamA {
            nCount
            oTeam {
              _id
              sAbbr
              sTitle
            }
          }
          oTeamB {
            nCount
            oTeam {
              _id
              sAbbr
              sTitle
            }
          }
          oCapFan {
            _id
          }
          oVCFan {
            _id
          }
          oTPFan {
            _id
          }
        }
        eLeague
      }
    }
  }
`

export const GET_COMMENTARY = gql`
  query ListMatchCommentaries($input: oListMatchCommentaryFrontInput) {
    listMatchCommentaries(input: $input) {
      ${commentaryData}
    }
  }
`

export const commentaryV2Responce = `
_id
sCommentary
eEvent
nInningNumber
sScore
sOver
sBall
nRuns
aOverScores
sEventId
nInningNumber
aBatters {
  iBatterId
  nBallFaced
  nRuns
}
aBowlers {
  iBowlerId
  sOvers
  nMaidens
  nRunsConceded
  nWickets
}
`

export const GET_COMMENTARY_V2 = gql`
  query ListMatchCommentariesV2($input: oListMatchCommentaryFrontInputV2) {
    listMatchCommentariesV2(input: $input) {
      ${commentaryV2Responce}
      # Schema requirements
      oWicketBatter {
        sFullName
        sShortName
      }
      nBatterRuns
      nBatterBalls
      sHowOut
      dCreated
      dUpdated
    }
  }
`

// export const GET_MATCH_INFO = gql`
//   query GetMatchInfoFront($input: oGetMatchInfoFrontInput) {
//     getMatchInfoFront(input: $input) {
//       sPitchCondition
//       oTeam1 {
//         oTeam {
//           sTitle
//         }
//         aPlayers {
//           bPlaying11
//           sRoleStr
//           oPlayer {
//             sPlayingRole
//             sFullName
//           }
//         }
//       }
//       oMatch {
//         dStartDate
//         sTitle
//         oSeries {
//           sTitle
//         }
//         oVenue {
//           sName
//         }
//         sUmpires
//         sReferee
//         oToss {
//           sText
//         }
//       }
//       oTeam2 {
//         oTeam {
//           sTitle
//         }
//         aPlayers {
//           bPlaying11
//           sRoleStr
//           oPlayer {
//             sPlayingRole
//             sFullName
//           }
//         }
//       }
//       oWinnerTeam {
//         sTitle
//       }
//       sAvgScore
//       sWeatherReport
//     }
//   }
// `

export const GET_MATCH_OVERVIEW = gql`
  query GetMatchOverviewFront($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      aCricPrediction {
        ePlatformType
        oSeo {
          sSlug
        }
      }
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oImg {
              sUrl
              sText
            }
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          sTitle
          sAbbr
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oImg {
              sUrl
              sText
            }
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          sTitle
          sAbbr
        }
      }
      sMatchPreview
      sPitchCondition
      sWeatherReport
      sAvgScore
      oWinnerTeam {
        sTitle
      }
    }
  }
`

export const GET_MATCH_PLAYING_XI = gql`
  query GetMatchOverviewFront($input: oGetMatchOverviewFrontInput!) {
    getMatchOverviewFront(input: $input) {
      oTeam1 {
        aPlayers {
          bPlaying11
          bSubstitute
          sSplRoleStr
          eSquadChange
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oImg {
              sUrl
              sText
            }
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          oJersey {
            sUrl
            sText
          }
          _id
          sAbbr
          sTitle
        }
      }
      oTeam2 {
        aPlayers {
          bPlaying11
          bSubstitute
          sSplRoleStr
          eSquadChange
          oPlayer {
            _id
            eTagStatus
            sFullName
            sFirstName
            sCountryFull
            oImg {
              sUrl
              sText
            }
            oSeo {
              sSlug
            }
          }
          sRoleStr
        }
        oTeam {
          oJersey {
            sUrl
            sText
          }
          _id
          sAbbr
          sTitle
        }
      }
    }
  }
`

export const GET_MATCH_SQUAD = gql`
  query ListMatchSquad($input: oListMatchSquadInput) {
    listMatchSquad(input: $input) {
      bPlaying11
      iPlayerId
      oTeam {
        sAbbr
        sTitle
        _id
      }
      sName
      sRoleStr
    }
  }
`

export const GET_MATCH_OVERS = gql`
query ListMatchOvers($input: oListMatchOverFrontInput) {
  listMatchOvers(input: $input) {
    nTotal
    aResults {
      ${oversData}
    }
  }
}
`

export const RECENT_OVER = gql`
query ListMatchOvers($input: oListMatchOverFrontInput) {
  listMatchOvers(input: $input) {
    aResults {
      aBall {
        sScore
        nRuns
        sOver
      }
      sOver
    }
  }
}
`
